import Vue from 'vue'

import { mapGetters } from 'vuex'

import template from './index.pug'

import Search from './_search.js'

import DigitalSupportMovement from './digital_support_movement.js'

import ProductMovement from './product_movement.js'


// Se evitan las recargas parciales, preadquisiciones y las validaciones parciales
const AVOID_TYPES = [12, 14, 19]
//Se van a incluir las recargas y las validaciones 5, 8, 13, 15
const TYPE_FLAT_RATE = 13
const TYPE_CHARGE = 15
const TYPE_RECHARGE = 16
const TYPE_PARTIAL_VALIDATION = 12
export default Vue.extend({
  name: 'movements-history-page',
  template: template(),
  components: {
    Search,
    DigitalSupportMovement,
    ProductMovement
  },
  data() {
    return {
      movimientos: [],
      valido: false,
      isLoading: false
    }
  },
  
  methods: {

    handleMovements(movimientos) {
      this.isLoading = false;
      // Solo filtrar los tipos a evitar si hay movimientos
      if (movimientos && movimientos.length > 0) {
        this.movimientos = [...movimientos.filter(movimiento => !AVOID_TYPES.includes(movimiento.type))]
      } else {
        this.movimientos = []
      }
    },

    handleValidation(valido) {
      this.valido = valido
      if (!valido){
        this.movimientos = []
      } else {
        this.isLoading = true;
      }
    },

    isProductPass(movimiento) {
      return movimiento.type === TYPE_FLAT_RATE || movimiento.type === TYPE_CHARGE || movimiento.type === TYPE_RECHARGE
    }

  }
})
